import React from 'react';
import { Form, Input, Button, notification } from 'antd';
import { getAccessTokenApi } from '../../../api/auth';
import { validateReportAccessCodeInactiveApi } from '../../../api/user';
import { userLogOut } from '../../../utils/general';

import './AuthAdminForm.scss';

const AuthAdminForm = (props) => {
    const { setIsAuth } = props;

    const layout = {
        labelCol: { span: 12 },
        wrapperCol: { span: 12 },
    };

    const tailLayout = {
        wrapperCol: { offset: 2, span: 12 },
    };

    const onFinish = async (values) => {
        const { code } = values;
        const token = getAccessTokenApi();
        if (token == null) {
            userLogOut();
            return;
        }
        const result = await validateReportAccessCodeInactiveApi(token, code);

        if (result?.status === 200) {
            notification['success']({
                message: 'Bienvenido.',
            });
            setIsAuth(true);
        } else {
            notification['error']({
                message: 'No tiene permiso.',
            });
        }
    };

    return (
        <Form
            {...layout}
            name='basic'
            onFinish={onFinish}
            className='auth-admin-form'
        >
            <Form.Item
                label='Código'
                name='code'
                rules={[
                    {
                        required: true,
                        message: 'Ingrese un código',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item {...tailLayout}>
                <Button type='primary' htmlType='submit' size='large'>
                    Enviar
                </Button>
            </Form.Item>
        </Form>
    );
};

export default AuthAdminForm;
